import { FlyoutService, IFlyout } from '../../shared/flyout.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../../shared/menu.service';
import { DocumentenComponent } from '../documenten/documenten.component';
import { KalenderComponent } from '../kalender/kalender.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: true,
    imports: [KalenderComponent, DocumentenComponent]
})
export class DashboardComponent implements OnInit {

    constructor() {}

    ngOnInit() {
    }

}
